import { Api } from "../config/request";

export default {
    bulkUploadDriverPolygonId(payload) {
        return Api.post("/driver-polygon/id-bulk-upload", payload);
    },
};